export default __webpack_public_path__ + "static/media/cappi-logo.fa6af7aa.png";